import styled from "styled-components";
import * as React from "react";
import BtnDelete from "./btn/btn_delete";
import Paragraph from "./text/paragraph";

interface IProps {
    handleDeleteCustomerBlackListSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void
    domain: string;
    deleteValue: number;
}

const ButtonDeletePermanentLink: React.FC<IProps> = (props) => {

    const { domain, handleDeleteCustomerBlackListSubmit, deleteValue } = props;
    const href:string = `https://${domain}`;

    return(
        <Flex>
            <BtnDeleteWrapper>
                <BtnDelete onClick={handleDeleteCustomerBlackListSubmit} value={deleteValue} />
            </BtnDeleteWrapper>
            <Paragraph>
                <PermanentLink
                    href={href}
                    target="_blank"
                >
                    {domain}
                </PermanentLink>
            </Paragraph>
        </Flex>
    )
};

export default ButtonDeletePermanentLink

const Flex = styled.div`
    display: flex;
    align-items: center;
`;

const BtnDeleteWrapper = styled.div`
    margin-right: 10px;
`;

const PermanentLink = styled.a`
    color: inherit;
`;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/button_delete_permanent_link.tsx